import React, { FC } from 'react';
import { ReactComponent as ArrowUpIcon } from 'assets/icons/arrow-up-icon.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-circle-icon.svg';
import { formatNumber } from 'utils/functions';
import { useNavigate } from 'react-router-dom';

type StatsType = 'increase' | 'decrease' | 'online';

export type BaseStatsType = {
  title: string;
  value: string;
  withNaira?: boolean;
  time?: string;
  type?: StatsType;
  weeklyVal?: string | number;
  small?: boolean;
  activeDateRange?: string;
  loading?: boolean;
  route?: string;
};
const BaseStats: FC<BaseStatsType> = ({
  title,
  value,
  withNaira = false,
  time,
  type,
  weeklyVal = '',
  small,
  loading,
  activeDateRange,
  route
}) => {
  const numberFormat: Intl.NumberFormatOptions = {
    style: withNaira ? 'currency' : 'decimal',
    minimumFractionDigits: withNaira ? 2 : 0,
    maximumFractionDigits: withNaira ? 2 : 0
  };
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        if (route) {
          navigate(route);
        }
      }}
      className={`flex flex-col text-center lg:text-left lg:items-start ${
        small ? 'gap-1' : 'gap-3'
      }`}>
      <label className={`${small ? 'text-[10px]' : 'text-xs'} uppercase text-gray-8`}>
        {title}
      </label>
      <label
        className={`${
          small ? 'font-medium text-base' : 'font-semibold text-xl md:text-3xl'
        }  text-gray-6 `}>
        {loading ? '- -' : withNaira ? formatNumber(value, numberFormat) : value}
        {time && ` ${time}`}
      </label>
      {type === 'online' ? (
        <label
          className={`text-green-5 text-sm flex items-center justify-center gap-1 ${
            small ? 'text-[10px]' : ''
          }`}>
          <p className='w-2 h-2 rounded-full bg-green-5'></p>
          {weeklyVal ? (
            <>
              <span className='font-medium'>{formatNumber(weeklyVal)}</span>
              <span> online </span>
            </>
          ) : (
            <span> Live </span>
          )}
        </label>
      ) : (
        <label
          className={`text-sm flex items-center gap-1 ${small && 'text-[10px]'} ${
            type === 'increase' ? 'text-green-5' : 'text-red-5'
          }`}>
          {type === 'increase' ? <ArrowUpIcon /> : <ArrowDownIcon />}
          <span className='font-medium'>{formatNumber(weeklyVal, numberFormat)}</span>
          <span className=' text-gray-8 lowercase'> {activeDateRange} </span>
        </label>
      )}
    </div>
  );
};

export default BaseStats;
